
import { UserModel } from "@/Domains/User";
import { AppEnum, formatName, OptionHelper, RecordMap } from "@/Shared";
import { AgentTargetFormValues } from "../AgentTargetFormValidation";
import { AgentTargetModel } from "../AgentTargetModel";

export class AgentTargetFormViewModel {
    public id: number;
    public agentId: number;
    public year: number;

    public rentalTarget?: number;
    public salesTarget?: number;
    public otherProductsTarget?: number;
    public caTarget?: number;
    public mandatesTarget?: number;

    public agent?: UserModel | null;

    private _agentOptions = [] as AppEnum[];

    private _title? : string;

    public constructor(
        private userMap: RecordMap<UserModel>,
        private _agentTarget?: AgentTargetModel,
        private user? : UserModel
    ) {
        this.id = _agentTarget?.id ?? 0;
        
        this.year = _agentTarget?.year ?? new Date().getFullYear();

        this.rentalTarget = _agentTarget?.rentalTarget;
        this.salesTarget = _agentTarget?.salesTarget;
        this.otherProductsTarget = _agentTarget?.otherProductsTarget;
        this.caTarget = _agentTarget?.caTarget;
        this.mandatesTarget = _agentTarget?.mandatesTarget;

        this.agent = this.user ?? _agentTarget?.agent ?? null;
        this.agentId = this.user?.id ??_agentTarget?.agentId ?? 0;
        this._agentOptions = OptionHelper.userOptions(this.userMap.toArray());

    
    }

    // Renvoie les valeurs à soumettre
    get formValues(): AgentTargetFormValues {
        return {
            id: this.id,
            agentId: this.agentId,
            year: this.year,
            rentalTarget: this.rentalTarget,
            salesTarget: this.salesTarget,
            otherProductsTarget: this.otherProductsTarget,
            caTarget: this.caTarget,
            mandatesTarget: this.mandatesTarget,
        } as AgentTargetFormValues;
    }

    public get agentOptions() {
        return this._agentOptions;
    }

    // Titre dynamique
    get title(): string {
        if (this._agentTarget) {
            const agentName = this.agent? formatName(this.agent?.person) : `ID ${this.agentId}`;
            return `Objectif Agent N°${this.id} - ${agentName} (${this.year})`;
        }
        return "Création d'un Objectif Agent";
    }

    // Mode création ou édition
    isCreationMode = (): boolean => !this.id;
}
